import { FormatStyle } from "./enums/SaveMode";
import { ModelMapAbstract } from "./ModelMapAbstract";

export class VehicleModel { }


export interface VehicleMaster {
    VehicleID: number;
    VehicleName: string;
    VehicleCode:string;
    ChasisNo: string;
    EngineNo: string;
    RcNumber: string;
    RcDateFrom: Date;
    RcDateTo: Date;
    InsuranceNo: string;
    InsuranceFrom: Date;
    InsuranceTo: Date;
    PocDateFrom: Date;
    PocDateTo: Date;
    SeatNo: number;
    IsActive: boolean;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
    LocationId: number;
}


export class ViewVehicle {
    VehicleID: number;
    VehicleName: string;
    VehicleCode:string;
    ChasisNo: string;
    EngineNo: string;
    RcNumber: string;
    RcDateFrom: Date;
    RcDateTo: Date;
    InsuranceNo: string;
    InsuranceFrom: Date;
    InsuranceTo: Date;
    PocDateFrom: Date;
    PocDateTo: Date;
    SeatNo: number;
    IsActive: boolean;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
    LocationId: number;
    Location: string;
}


export class VehicleModelMap implements ModelMapAbstract {
    fieldSettings: (string | number)[][] = [
        ['Vehicle Code', 'VehicleCode', FormatStyle.None],
        ['Vehicle Name', 'VehicleName', FormatStyle.None],
        ['Seat No', 'SeatNo', FormatStyle.None],
        ['Chasis No', 'ChasisNo', FormatStyle.None],
        ['Engine No', 'EngineNo', FormatStyle.None],
        ['RC Number No', 'RcNumber', FormatStyle.None],
        ['Rc Date From', 'RcDateFrom', FormatStyle.DDMMYYYY],
        ['Rc Date To', 'RcDateTo', FormatStyle.DDMMYYYY],
        ['Insurance No', 'InsuranceNo', FormatStyle.None],
        ['Insurance Date From', 'InsuranceFrom', FormatStyle.DDMMYYYY],
        ['Insurance Date To', 'InsuranceTo', FormatStyle.DDMMYYYY],
        ['POC Date From', 'PocDateFrom', FormatStyle.DDMMYYYY],
        ['POC Date To', 'PocDateTo', FormatStyle.DDMMYYYY],
        ['Status', 'IsActive', FormatStyle.None]
    ];
}
